import React, { useEffect, useMemo, useState } from 'react';
import { useSettings } from 'hooks/useSettings';
import {
    EVENT_START_TIME,
    formatRemainingTimeLabel,
    formatUnitValue,
    getEventStartDate,
    getRemainingTime
} from 'utils/countdown';
import styles from './CountDownClock.module.scss';

const CountDownClock: React.FC<{ disabled?: boolean }> = ({ disabled }) => {
    const { settings } = useSettings();
    const [now, setNow] = useState(() => Date.now());

    const target = useMemo(
        () => (settings?.startDate ? getEventStartDate(settings.startDate) : null),
        [settings?.startDate]
    );

    useEffect(() => {
        if (disabled || !target) {
            return;
        }

        let timeoutId = 0;
        const tick = () => {
            setNow(Date.now());
            const delay = Math.max(25, 1000 - (Date.now() % 1000));
            timeoutId = window.setTimeout(tick, delay);
        };
        timeoutId = window.setTimeout(tick, Math.max(25, 1000 - (Date.now() % 1000)));

        return () => window.clearTimeout(timeoutId);
    }, [disabled, target]);

    if (disabled || !target || Number.isNaN(target.getTime())) {
        return null;
    }

    const remaining = getRemainingTime(target, new Date(now));
    const expired = remaining.totalMs === 0;

    return (
        <time
            className={styles.root}
            dateTime={`${settings?.startDate}T${EVENT_START_TIME}`}
            aria-label={formatRemainingTimeLabel(remaining)}
        >
            <table className={`${styles.table} ${expired ? styles.past : ''}`}>
                <tbody>
                    <tr>
                        <td>{remaining.days}</td>
                        <td>:</td>
                        <td>{formatUnitValue(remaining.hours)}</td>
                        <td>:</td>
                        <td>{formatUnitValue(remaining.minutes)}</td>
                        <td>:</td>
                        <td>{formatUnitValue(remaining.seconds)}</td>
                    </tr>
                    <tr className={styles.labels}>
                        <td>Days</td>
                        <td></td>
                        <td>Hrs</td>
                        <td></td>
                        <td>Mins</td>
                        <td></td>
                        <td>Secs</td>
                    </tr>
                </tbody>
            </table>
        </time>
    );
};

export default CountDownClock;
